import { Info, X } from "lucide-react";
import { type Roles } from "./RoleSwitcher";
import { twMerge } from "tailwind-merge";
import { AnimatePresence, motion } from "framer-motion";
import { useSubMenu } from "../SubMenuContext";
import { useRef, useState } from "react";

const RoleInfo = ({ role }: { role: Roles }) => {
    const { isSidebarOpen } = useSubMenu();
    const hideMsgLocal = localStorage.getItem('empreender-lib-ovni-hide-msg');
    const [isMsgClosed, setIsMsgClosed] = useState(hideMsgLocal ? true : false);
    const firstRender = useRef(true);

    const rolesInfo = {
        creator: {
            msg: (
                <>
                    Mostre seu perfil, participe de campanhas e ganhe dinheiro.
                </>
            ),
            color: `text-[#E52E7A]`,
        },
        lojista: {
            msg: (
                <>
                    Ative campanhas, recrute creators e venda com afiliados.
                </>
            ),
            color: `text-indigo-600`,
        }
    }

    const animation = {
        initial: { opacity: firstRender.current ? 1 : 0, y: firstRender.current ? 0 : -10 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 10 },
        transition: {
            duration: .2
        }
    }

    const hideAnimation = {
        initial: {
            height: isMsgClosed ? 0 : isSidebarOpen ? 50 : 0,
            opacity: isMsgClosed ? 0 : isSidebarOpen ? 1 : 0,
            marginBottom: isMsgClosed ? 0 : isSidebarOpen ? 8 : 0,
        },
        animate: {
            height: isMsgClosed ? 0 : isSidebarOpen ? 50 : 0,
            opacity: isMsgClosed ? 0 : isSidebarOpen ? 1 : 0,
            marginBottom: isMsgClosed ? 0 : isSidebarOpen ? 8 : 0,
        },
        exit: {},
    }

    const closeMsg = () => {
        setIsMsgClosed(true);
        localStorage.setItem('empreender-lib-ovni-hide-msg', 'true');
    };

    return <>
        <motion.div {...hideAnimation} className="w-full h-[50px] mb-2 overflow-hidden">
            <AnimatePresence mode="wait">
                <motion.div {...animation} onAnimationComplete={() => (firstRender.current = false)}
                    className="border border-dashed rounded-lg bg-white p-2 w-full flex gap-2 justify-between" key={role}>
                    <div className="flex flex-row gap-2">
                        <div className={twMerge(`${rolesInfo[role].color} transition duration-300 pt-[2px]`)}>
                            <Info size={14} />
                        </div>
                        <p className="text-gray-500 font-sans text-[10px] font-normal leading-4 m-0 w-[154px]">
                            {rolesInfo[role].msg}
                        </p>
                    </div>
                    <div className="text-gray-400 cursor-pointer" onClick={closeMsg}>
                        <X size={12} />
                    </div>
                </motion.div>
            </AnimatePresence>
        </motion.div>

        <div className="w-full py-1 mb-2">
            <div className="bg-gray-200 h-px"></div>
        </div>
    </>
};

export default RoleInfo;